var _rect, _path, _path2, _rect2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutService3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.669922,
    y: 0.943359,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#33B4A0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.6699 39.4434C43.6689 43.4434 50.1699 50.4434 54.1699 59.4434",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1699 21.4434C35.1699 29.9434 42.6699 37.9434 44.1699 60.9434M46.1699 20.9434C45.0033 28.61 39.6699 46.5434 27.6699 56.9434",
    stroke: "white",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 37.6699,
    y: 36.9434,
    width: 5,
    height: 6,
    rx: 2.5,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6699 20.9434V57.3991L45.4477 60.9434L47.6699 20.9434H27.6699Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutService3);
export default __webpack_public_path__ + "static/media/about-service-3.74d73f55fc71b3f29499df2dbbc5d236.svg";
export { ForwardRef as ReactComponent };